export default __webpack_public_path__ + "static/media/blockfuse-logo.6affabd7.png";